export const reservasModals = {
  roomChange: {
    close: "Schließen",
    titleAssign: "Zimmer zuweisen",
    titleChange: "Zimmer wechseln",
    stopSoldNote:
      "Diese Zimmerkategorie ist an diesen Daten für den Verkauf gesperrt (Stop-Sell), Sie können die Zimmer aber weiterhin neu organisieren: Verschieben oder Zuweisen öffnet den Verkauf nicht wieder.",
    labelAssign: "Zuzuweisendes Zimmer",
    labelNew: "Neues Zimmer",
    selectPlaceholder: "Zimmer auswählen…",
    swapWith: "Tauschen mit {names}",
    swapWithType: "Tauschen mit {names} (wechselt zu {type})",
    swapTypeWarning: "Nach dem Tausch wechselt {names} zu {type} — nicht die gebuchte Kategorie.",
    swapGroup:
      "Gruppentausch: {name} und {also} ziehen in dieses Zimmer, und {incoming} ziehen in Ihres. Alles in einem einzigen Vorgang.",
    swapSingle:
      "Dieses Zimmer ist von {names} belegt. Beim Speichern werden sie {action}: Ihre Buchung zieht in dieses Zimmer und die andere(n) in Ihres.",
    swapWord: "getauscht",
    emptyNote:
      "Kein Zimmer ist im gesamten Zeitraum frei. Nutzen Sie die Schaltfläche {action} in der Spalte «Zu organisieren», um die Buchungen automatisch neu zu verteilen.",
    organizeWord: "Organisieren",
    sameTypeGroup: "Gleiche Kategorie · {name}",
    otherTypeGroup: "Andere Kategorie · {name}",
    typeChangeNote:
      "Die Buchung wird zu {type} verschoben. Ihre Daten werden aktualisiert, für beide Kategorien wird die Verfügbarkeit neu berechnet und die Kanäle werden benachrichtigt.",
    selectRoomError: "Sie müssen ein Zimmer auswählen",
    cancel: "Abbrechen",
    confirmSwap: "Tauschen",
    confirmAssign: "Zuweisen",
    confirmSave: "Änderung speichern",
  },
  outOfOrder: {
    titleMaintenance: "Zimmerwartung",
    titleActions: "Aktionen für die Zimmerkategorie",
    scopeLabel: "Geltungsbereich",
    scopeUnit: "Zimmerkategorie (alle)",
    scopeInstance: "Dieses Zimmer",
    actionLabel: "Aktion",
    actionOoo: "Außer Betrieb (Wartung)",
    actionOpen: "Im Zeitraum wieder öffnen",
    quantityLabel: "Anzahl der Zimmer",
    maxPerDay: "Bis zu {max} pro Tag.",
    dateRangeLabel: "Zeitraum",
    from: "Von",
    to: "Bis",
    cancel: "Abbrechen",
    apply: "Anwenden",
  },
  closeDay: {
    title: "Verfügbarkeit ändern",
    syncing: "Verfügbarkeit wird synchronisiert...",
    roomTypeLabel: "Zimmerkategorie",
    roomTypePlaceholder: "Zimmer auswählen",
    startDate: "Startdatum",
    endDate: "Enddatum",
    maxAvailable: "Maximum: {count} verfügbar",
    cancel: "Abbrechen",
    apply: "Änderung anwenden",
  },
  confirm: {
    defaultTitle: "Bestätigen?",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
  },
  updateAlert: {
    title: "Zimmer aktualisieren",
    sectionTitle: "Zimmerinformationen",
    nameLabel: "Zimmername oder -nummer",
    keyLabel: "Zugangsschlüssel",
    cancel: "Abbrechen",
    submit: "Zimmer aktualisieren",
    nameRequired: "Zimmername oder -nummer ist erforderlich",
  },
};
